import React from 'react';
import { PropTypes } from 'prop-types';
import dayjs from 'dayjs';

import { Box, Typography, Stack } from '@mui/material';

const Message = ({ message, currentUserId }) => {
  const isMyMessage = currentUserId === message.sender_id;

  return (
    <Stack
      direction="row"
      sx={{
        flexDirection: isMyMessage ? 'row-reverse' : 'row',
        marginBottom: '10px',
      }}
    >
      <Box
        sx={{
          justifyContent: isMyMessage ? 'flex-end' : 'flex-start',
        }}
      >
        <Box
          key={message.id}
          sx={{
            backgroundColor: isMyMessage ? 'rgb(228, 229, 243)' : 'rgb(238, 238, 238)',
            textAlign: isMyMessage ? 'right' : 'left',
            justifyContent: isMyMessage ? 'flex-end' : 'flex-start',
            padding: '10px',
            borderRadius: '4px',
            marginBottom: '4px',
          }}
        >
          <Typography>{message.processed_content}</Typography>
        </Box>
        <Box
          sx={{
            textAlign: isMyMessage ? 'right' : 'left',
            fontSize: '11px',
            color: 'rgb(153, 153, 153)',
          }}
        >
          {dayjs(message.created_at).format('h:mma')}
        </Box>
      </Box>
    </Stack>
  );
};

Message.propTypes = {
  message: PropTypes.object.isRequired,
  currentUserId: PropTypes.number.isRequired,
};

export default Message;
